exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unsaved-changes-card[data-v-385651b2]{position:relative;border-radius:8px!important}.close-btn[data-v-385651b2]{position:absolute!important;right:8px;top:8px;z-index:1}.warning-icon-wrapper[data-v-385651b2]{display:inline-block}.text-h6[data-v-385651b2]{color:#333}.text--secondary[data-v-385651b2]{color:#666!important}.v-btn--outlined[data-v-385651b2]{border-width:1px!important}", ""]);

// exports
